import type { FileWithPath } from 'react-dropzone';

import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { getPath } from '@/lib/api/path';

export const getTraceableApp = async (id: string) => {
  const res = await apiClient.GET(
    getPath('/v2/shadow-it/traceable-apps/{id}'),
    {
      params: { path: { id } },
    },
  );
  return getDataOrThrowApiError(res);
};

export const getTraceableApps = async (
  freeText?: string,
  page?: number,
  pageSize = 100,
) => {
  const res = await apiClient.GET(
    getPath('/v2/components/traceable-apps-for-select'),
    {
      params: { query: { freeText, page, pageSize } },
    },
  );
  return getDataOrThrowApiError(res);
};

export const getPresignedUrl = async (file: FileWithPath) => {
  const res = await apiClient.GET(getPath('/v2/s3/presigned-url/image'), {
    params: { query: { filename: file.name } },
  });
  return getDataOrThrowApiError(res);
};

export const uploadImage = async (url: string, file: FileWithPath) => {
  const res = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });
  return res;
};

export const getAppCategories = async () => {
  const res = await apiClient.GET('/v2/app-categories');
  return getDataOrThrowApiError(res);
};
